// extracted by mini-css-extract-plugin
export var actionButton = "_8p-1";
export var actionButtons = "_8p-2";
export var actions = "_8p-0";
export var aiUnread = "_8p-10";
export var alignCenter = "_8p-h";
export var backWrapper = "_8p-3";
export var cellContainer = "_8p-4";
export var checkboxContainer = "_8p-5";
export var contentContainer = "_8p-6";
export var contentHeader = "_8p-8";
export var conversationsTableWrapper = "_8p-s";
export var draftReplyBadgeContainer = "_8p-m";
export var dropdownItem = "_8p-b";
export var dropdownItemsContainer = "_8p-a";
export var dropdownTitle = "_8p-c";
export var errorIcon = "_8p-7";
export var filter = "_8p-d";
export var gray = "_8p-i";
export var headerActionButtons = "_8p-e";
export var headerCheckboxContainer = "_8p-f";
export var icon = "_8p-j";
export var menuContainer = "_8p-k";
export var noMoreTicketsIcon = "_8p-12";
export var noMoreTicketsSubText = "_8p-13";
export var oneLine = "_8p-l";
export var optionsButton = "_8p-n";
export var plus = "_8p-o";
export var portalButtonsWrapper = "_8p-g";
export var red = "_8p-p";
export var scrolledTop = "_8p-9";
export var search = "_8p-q";
export var selectedConversationsCount = "_8p-r";
export var spinner = "_8p-t";
export var strong = "_8p-u";
export var summaryCell = "_8p-v";
export var tableContainer = "_8p-11";
export var tagContainer = "_8p-w";
export var threeDots = "_8p-x";
export var twoLines = "_8p-y";
export var unread = "_8p-z";